var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#3A4860"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.736 37.72l-6.333-11.012H11.84l6.333 11.013h11.564z",
    fill: "#21E6C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.736 15.694l-6.333 11.013H11.84l6.333-11.013h11.564z",
    fill: "#278EA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.155 10.646l-2.983 5.048h11.564l-5.874-9.912-2.707 4.864z",
    fill: "#21E6C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.172 37.72l6.333-11.012h11.564L29.736 37.72H18.172z",
    fill: "#278EA5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.954 27.665l-5.782 10.056h11.564l-5.782-10.056z",
    fill: "#227E93"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.172 15.694l6.333 11.013h11.564l-6.333-11.013H18.172z",
    fill: "#21E6C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.736 15.694L23.954 25.75l-5.782-10.056h11.564z",
    fill: "#1AD0AE"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiMzQTQ4NjAiLz4KPHBhdGggZD0iTTI5LjczNjEgMzcuNzIwOUwyMy40MDM0IDI2LjcwNzZMMTEuODM5MyAyNi43MDc2TDE4LjE3MiAzNy43MjA5TDI5LjczNjEgMzcuNzIwOVoiIGZpbGw9IiMyMUU2QzEiLz4KPHBhdGggZD0iTTI5LjczNjEgMTUuNjk0MUwyMy40MDM0IDI2LjcwNzVMMTEuODM5MyAyNi43MDc1TDE4LjE3MiAxNS42OTQxTDI5LjczNjEgMTUuNjk0MVoiIGZpbGw9IiMyNzhFQTUiLz4KPHBhdGggZD0iTTIxLjE1NDkgMTAuNjQ2MkwxOC4xNzIxIDE1LjY5NEwyOS43MzYyIDE1LjY5NEwyMy44NjI0IDUuNzgxOThMMjEuMTU0OSAxMC42NDYyWiIgZmlsbD0iIzIxRTZDMSIvPgo8cGF0aCBkPSJNMTguMTcyMSAzNy43MjA5TDI0LjUwNDggMjYuNzA3NkwzNi4wNjg5IDI2LjcwNzZMMjkuNzM2MiAzNy43MjA5TDE4LjE3MjEgMzcuNzIwOVoiIGZpbGw9IiMyNzhFQTUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMy45NTM5IDI3LjY2NUwxOC4xNzE5IDM3LjcyMDdIMjkuNzM1OUwyMy45NTM5IDI3LjY2NVoiIGZpbGw9IiMyMjdFOTMiLz4KPHBhdGggZD0iTTE4LjE3MjEgMTUuNjk0MUwyNC41MDQ4IDI2LjcwNzVMMzYuMDY4OSAyNi43MDc1TDI5LjczNjIgMTUuNjk0MUwxOC4xNzIxIDE1LjY5NDFaIiBmaWxsPSIjMjFFNkMxIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjkuNzM2IDE1LjY5NDFMMjMuOTU0MSAyNS43NDk3TDE4LjE3MjEgMTUuNjk0MUgyOS43MzZaIiBmaWxsPSIjMUFEMEFFIi8+Cjwvc3ZnPgo=";
export { SvgLogo as ReactComponent };